export default {"src":"/_next/static/media/fantom-explorer.383bcaeb.svg","height":73,"width":73,"blurWidth":0,"blurHeight":0};